<div class="app-form-by-key">
    <formio [formKey]="formKey" [submission]="submission" (formLoad)="formLoad($event)" (beforeSubmit)="beforeSubmit($event)"
        (submit)="submit($event)" (customEvent)="customEvent($event)" (change)="change($event)" [readOnly]="readOnly" [viewOnly]="viewOnly"></formio>
</div>